/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Untitledthread1Inputs */

const zh_usage_untitledthread1 = /** @type {(inputs: Usage_Untitledthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名会话`)
};

const en_usage_untitledthread1 = /** @type {(inputs: Usage_Untitledthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled conversation`)
};

const es_usage_untitledthread1 = /** @type {(inputs: Usage_Untitledthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación sin título`)
};

/**
* | output |
* | --- |
* | "Untitled conversation" |
*
* @param {Usage_Untitledthread1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_untitledthread1 = /** @type {((inputs?: Usage_Untitledthread1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Untitledthread1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_untitledthread1(inputs)
	if (locale === "en") return en_usage_untitledthread1(inputs)
	return es_usage_untitledthread1(inputs)
});
export { usage_untitledthread1 as "usage_untitledThread" }